<script setup lang="ts">
import FormContainer from './components/container/Container.vue';
import type { Form } from './types';
import { useFormFillStore } from 'vince-core/pages/form-builder/formFillStore';

const props = defineProps<{
    form: Form,
    preview?: boolean,
    data?: unknown
}>();

const store = useFormFillStore();

onMounted(() => {
    store.initialize(props.form, props.data ? props.data : {}, props.preview);
});
</script>
<template>
    <div>
        <form-container :element="form.container" />
    </div>
</template>
